import { render } from "./ColumnsPlay.vue?vue&type=template&id=030e9496&scoped=true"
import script from "./ColumnsPlay.vue?vue&type=script&lang=js"
export * from "./ColumnsPlay.vue?vue&type=script&lang=js"

import "./ColumnsPlay.vue?vue&type=style&index=0&id=030e9496&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-030e9496"

export default script